<template>
    <div id="app">
        <Header></Header>
        <main class="adjuster">
            <div class="card">
                {{ title }}
            </div>
            <div class="card">
                {{ content }}
            </div>
            <div class="card">
                <div v-for="task of tasks" :key="task.id">
                    <a :href="`/codelab/task?id=${ task.id }`">{{ task.title }}</a>
                </div>
            </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '../components/Header.vue';
import Footer from '@/components/Footer';
import { getSSRdata } from '../../../utils/utils';

export default {
    data: () => ({
        title: "",
        content: "",
        tasks: [],
    }),
    created() {
        getSSRdata("lesson");
    },
    methods: {

    },
    components: {
        Header, Footer,
    }
}
</script>

<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
</style>